export const posts = [
  {
    id: 'meeting-ppt-tongue-twister',
    title: '周一晨会，我把老板那页满是名词的PPT念成了绕口令',
    channel: 'moyu',
    channelName: '摸鱼段子',
    excerpt: '本来只想照着念，结果那页叠了七个「赋能」，我一口气念完，全场安静了三秒，然后有人在憋笑。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20orange%20toned%20minimal%20office%20meeting%20room%20with%20a%20projector%20screen%20and%20coffee%20cups%2C%20soft%20morning%20light%2C%20clean%20editorial%20illustration%20style%2C%20no%20people%20faces%2C%20cozy%20and%20slightly%20playful%20mood&width=1200&height=800&seq=chigua-post-01&orientation=landscape',
    author: '瓜田小队长',
    date: '2026-09-08',
    readMinutes: 3,
    likes: 4821,
    comments: 316,
    heat: 98,
    tags: ['打工人日常', '公司迷惑行为'],
    highlight: '那一刻我明白了，有些PPT不是用来讲的，是用来绕的。',
    paragraphs: [
      '周一的晨会永远有一种神奇的魔力，它能让一个精神抖擞的人在三分钟内进入待机状态。我本来只是个负责念PPT的工具人，只要照着屏幕上的字读完，这个环节就算过去了。',
      '结果那页PPT上叠了七个「赋能」、五个「闭环」，还有一句长达二十八个字的句子。我一开始还想给它断句，后来发现根本断不了，只能一口气念完，像在报菜名。',
      '念完之后，会议室陷入了长达三秒的安静。那种安静不是感动，是在消化。坐在我对面的同事肩膀在轻微抖动，我怀疑他正把笑憋成咳嗽。',
      '老板倒是很满意，说这页讲得「很有气势」。我点点头，心想有些内容确实不是用来理解的，是用来念的。',
    ],
  },
  {
    id: 'takeout-micro-spicy',
    title: '外卖点了一份「微辣」，辣到和同事抢饮水机',
    channel: 'xiafan',
    channelName: '下饭专区',
    excerpt: '商家说微辣只是「稍微有一点点点」，我信了，现在我的舌头正在申请离职。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20top%20down%20takeout%20noodle%20box%20with%20red%20chili%20oil%20and%20chopsticks%20on%20a%20cream%20table%2C%20steam%20rising%2C%20appetizing%20soft%20lighting%2C%20clean%20simple%20background%2C%20editorial%20food%20photography&width=1200&height=800&seq=chigua-post-02&orientation=landscape',
    author: '干饭不积极',
    date: '2026-09-07',
    readMinutes: 2,
    likes: 6390,
    comments: 428,
    heat: 95,
    tags: ['外卖刺客', '打工人日常'],
    highlight: '商家心里的「微」，和我心里的「微」，显然不是一个单位。',
    paragraphs: [
      '点外卖的时候我特意在备注里写了「微辣，谢谢」，还觉得这样显得自己很讲武德。商家回复得也很快，说「放心，微辣只是稍微有一点点点」。',
      '外卖到手，第一口下去我就知道这个「点」字用得非常有勇气。那种辣不是刺激，是有预谋的，从舌尖一路推进到耳根，最后在我的额头上盖了个章。',
      '我当场起身去找饮水机，结果发现隔壁工位的同事也在那儿，手里捧着杯子。我们对视一眼，什么都没说，但都懂了。',
      '后来我学乖了，备注改成了「不要辣，一点都不要，拜托」。这次商家回得依旧很快：「好的，微辣。」',
    ],
  },
  {
    id: 'team-building-werewolf',
    title: '公司团建玩狼人杀，HR全程当「上帝」还自带解说',
    channel: 'mihuo',
    channelName: '迷惑行为',
    excerpt: '别人玩的是推理，我们玩的是HR的即兴单口，每轮发言都配一段人物小传。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cream%20and%20orange%20toned%20cozy%20table%20game%20night%20scene%20with%20playing%20cards%20and%20teacups%20on%20a%20wooden%20table%2C%20soft%20lamp%20light%2C%20illustration%20style%2C%20no%20readable%20text%2C%20warm%20friendly%20mood&width=1200&height=800&seq=chigua-post-03&orientation=landscape',
    author: '瓜田观察员',
    date: '2026-09-05',
    readMinutes: 4,
    likes: 3210,
    comments: 205,
    heat: 87,
    tags: ['公司迷惑行为', '打工人日常'],
    highlight: '我们本来只是想玩个游戏，结果听了一场关于「狼人心理侧写」的分享。',
    paragraphs: [
      '团建那天晚上，大家围坐一圈准备玩狼人杀。HR说由她来当「上帝」，我们也没多想，毕竟她平时就很会控场。',
      '第一局开始，她开口的瞬间画风就变了。她不只是报流程，还给每个角色配了背景故事，说「三号位这位玩家，白天看起来很沉默，但沉默往往是狼的保护色」。',
      '我们本来还在认真推理，后来发现根本不用推理，跟着HR的解说走就行。她甚至会在关键回合停顿两秒，制造悬念，然后轻声说「现在，请闭眼」。',
      '那一晚我们没分出几局胜负，但每个人都记住了自己的人物小传。有人说这才是团建的最高境界，让打工人第一次觉得自己像主角。',
    ],
  },
  {
    id: 'excel-draw-dragon',
    title: '为了躲加班，我学会了用Excel画龙',
    channel: 'moyu',
    channelName: '摸鱼段子',
    excerpt: '当你能把表格单元格拼成一条龙，就没人再怀疑你「很忙」了。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20orange%20and%20cream%20toned%20laptop%20on%20a%20desk%20displaying%20a%20colorful%20pixel%20grid%20spreadsheet%2C%20cozy%20evening%20desk%20lamp%2C%20clean%20minimal%20style%2C%20soft%20shadows%2C%20playful%20editorial%20illustration&width=1200&height=800&seq=chigua-post-04&orientation=landscape',
    author: '工位隐士',
    date: '2026-09-04',
    readMinutes: 3,
    likes: 5570,
    comments: 372,
    heat: 92,
    tags: ['打工人日常', '摸鱼'],
    highlight: '摸鱼摸出专业技能，是打工人最后的体面。',
    paragraphs: [
      '事情的开端很朴素：下班前十分钟，群里弹出一条「这个需求今天能出吗」。我看了眼时间，又看了眼还没拆的泡面，决定做点什么。',
      '我开始研究怎么用单元格填色拼图案。一开始只是拼几个方块，后来越拼越上头，居然拼出了一条完整的龙，还带鳞片渐变。',
      '当同事路过我的工位，看到屏幕上那条色彩斑斓的「数据可视化」时，他沉默了一下，说：「你这表做得挺讲究啊。」',
      '那天我如愿准时下班。第二天我的Excel作品在部门内部传开了，有人来问我要教程。我忽然意识到，摸鱼有时候真的能摸出点东西来。',
    ],
  },
  {
    id: 'roommate-fried-chicken',
    title: '室友宣布减肥的第三小时，点了三份炸鸡',
    channel: 'xiafan',
    channelName: '下饭专区',
    excerpt: '他的理论很完整：这叫欺骗餐，专门用来欺骗自己的那种。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20crispy%20fried%20chicken%20in%20a%20paper%20box%20on%20a%20cream%20table%20with%20sauce%20cups%2C%20soft%20warm%20lighting%2C%20simple%20clean%20background%2C%20appetizing%20editorial%20food%20photography&width=1200&height=800&seq=chigua-post-05&orientation=landscape',
    author: '深夜食堂常客',
    date: '2026-09-03',
    readMinutes: 2,
    likes: 7140,
    comments: 512,
    heat: 96,
    tags: ['外卖刺客', '宿舍名场面'],
    highlight: '减肥这件事，计划是白天的，执行是晚上的。',
    paragraphs: [
      '晚上七点，室友在群里发了一张健身房的照片，配文「今天开始，认真减肥」。我们都给他点了赞，气氛非常励志。',
      '晚上十点，外卖小哥按响了门铃。室友抱着三份炸鸡回来，神情庄严，像完成某种仪式。',
      '我问他不是减肥吗，他说这叫「欺骗餐」。我追问欺骗谁，他想了想说：「主要欺骗我自己。」',
      '于是那天晚上我们一边吃炸鸡一边看剧，聊到凌晨。第二天他又发了健身房的照片，我们依旧点赞，谁也没提炸鸡的事。',
    ],
  },
  {
    id: 'subway-chujun-biao',
    title: '地铁上有人背《出师表》，整个车厢安静得像考场',
    channel: 'shadiaotujian',
    channelName: '沙雕图鉴',
    excerpt: '没有喇叭，没有音乐，就一个人低声背古文，全车厢自动进入静音模式。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20illustration%20of%20a%20quiet%20subway%20carriage%20with%20empty%20seats%20and%20soft%20ceiling%20lights%2C%20minimal%20warm%20palette%2C%20calm%20atmospheric%20editorial%20style%2C%20no%20people%20faces&width=1200&height=800&seq=chigua-post-06&orientation=landscape',
    author: '通勤观察日记',
    date: '2026-09-02',
    readMinutes: 3,
    likes: 4080,
    comments: 264,
    heat: 84,
    tags: ['地铁奇遇', '打工人日常'],
    highlight: '那一天，整节车厢都在陪他复(yu)习(xi)。',
    paragraphs: [
      '早高峰的地铁一向热闹，手机外放、电话会议、早餐香味，各种声音交错。那天却出了个例外。',
      '一位大哥站在门边，低声背起了《出师表》，「先帝创业未半而中道崩殂」。声音不大，但咬字特别清楚。',
      '神奇的事情发生了：旁边刷视频的人默默戴上了耳机，打电话的人走到车厢另一头，整个车厢慢慢安静下来，安静得像考场。',
      '他背到「今当远离，临表涕零」的时候，我旁边的小哥甚至轻轻点了一下头。到站开门那一刻，大家才像是被放行一样陆续下车。',
    ],
  },
  {
    id: 'binge-watch-3am',
    title: '追剧追到凌晨三点，第二天开会全程「魂穿」',
    channel: 'regua',
    channelName: '今日热瓜',
    excerpt: '别人开会记要点，我开会记台词，还差点站起来喊「我不服」。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20toned%20cozy%20living%20room%20at%20night%20with%20a%20glowing%20tv%20and%20a%20throw%20blanket%20on%20the%20sofa%2C%20soft%20warm%20lamplight%2C%20minimal%20editorial%20illustration%2C%20relaxed%20sleepy%20mood&width=1200&height=800&seq=chigua-post-07&orientation=landscape',
    author: '熬夜冠军',
    date: '2026-09-01',
    readMinutes: 3,
    likes: 5940,
    comments: 401,
    heat: 93,
    tags: ['熬夜追剧', '打工人日常'],
    highlight: '熬夜一时爽，开会火葬场，但剧是真的好看。',
    paragraphs: [
      '本来只想看一集，结果每一集结尾都留了个钩子，我的手就跟着自动播放一起滑走了。等我反应过来，窗外已经泛白。',
      '第二天开会，我坐在会议室里，眼睛睁着，灵魂还在昨晚的剧情里。别人记要点，我脑子里循环的是男主角那句台词。',
      '领导问我有什么想法，我差点脱口而出「我不服」。好在我及时改成「我觉得可以再研究研究」，保住了这个月的全勤。',
      '散会后我做了个决定：以后追剧，先把自动播放关掉。这个决定我大概已经做过十七次了。',
    ],
  },
  {
    id: 'cat-id-photo',
    title: '把猫的照片P成证件照，HR问我「这是谁」',
    channel: 'shadiaotujian',
    channelName: '沙雕图鉴',
    excerpt: '一只猫，白底，正脸，表情严肃，看起来比我还适合这个岗位。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20portrait%20of%20a%20fluffy%20orange%20cat%20sitting%20upright%20against%20a%20plain%20warm%20beige%20background%2C%20serious%20funny%20expression%2C%20soft%20even%20lighting%2C%20clean%20simple%20studio%20photography%20style&width=1200&height=800&seq=chigua-post-08&orientation=landscape',
    author: '猫毛收集者',
    date: '2026-08-30',
    readMinutes: 2,
    likes: 8620,
    comments: 690,
    heat: 97,
    tags: ['猫奴现状', '公司迷惑行为'],
    highlight: 'HR沉默的那五秒，我怀疑她真的在考虑要不要录用它。',
    paragraphs: [
      '周末闲着没事，我给家里那只橘猫拍了张正脸照，然后手一抖，把它抠图放进了蓝底证件照模板里，还顺手补了个白衬衫领子。',
      '效果意外地好。它坐得笔直，眼神坚定，嘴角带着一种「我很可靠」的严肃感，看起来比我更适合上班。',
      '周一我不小心把这张图发进了工作群，HR回了一句「这是谁」。我解释说是我的猫，群里安静了五秒，然后整层楼都知道了。',
      '后来这张「猫的证件照」成了部门群的吉祥物。有同事说，看着它的眼神，确实会想努力工作一点。',
    ],
  },
  {
    id: 'canteen-auntie-hand-shake',
    title: '食堂阿姨手抖传说，一勺土豆丝半勺是缘分',
    channel: 'xiafan',
    channelName: '下饭专区',
    excerpt: '她不是在打菜，是在做概率实验，每一勺都充满未知。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20orange%20toned%20canteen%20tray%20with%20shredded%20potato%20stir%20fry%20and%20steamed%20rice%20on%20a%20cream%20table%2C%20appetizing%20soft%20lighting%2C%20clean%20simple%20background%2C%20editorial%20food%20photography&width=1200&height=800&seq=chigua-post-09&orientation=landscape',
    author: '干饭不积极',
    date: '2026-08-29',
    readMinutes: 2,
    likes: 5230,
    comments: 358,
    heat: 89,
    tags: ['食堂阿姨手抖', '打工人日常'],
    highlight: '后来我不再期待分量稳定，只期待今天运气好一点。',
    paragraphs: [
      '公司食堂的王阿姨有一项绝技：无论你多饿，她的勺子总会恰到好处地抖一下。这一抖，改变的可能是你整个下午的心情。',
      '点一勺土豆丝，抖完剩半勺。点一份红烧肉，抖完剩三块。我们私底下把这件事称为「勺子的随机数」。',
      '有一次我前面的同事鼓起勇气说「阿姨，我加班了，能多一点吗」，阿姨愣了一下，勺子在半空中停了停，最后没有抖。',
      '那天他端着满满一盘坐下的表情，我至今记得。原来对付不确定的最好方式，是把话说出口。',
    ],
  },
  {
    id: 'moyu-weekly-report-guide',
    title: '打工人摸鱼指南：如何优雅地假装在写周报',
    channel: 'moyu',
    channelName: '摸鱼段子',
    excerpt: '键盘敲得响，光标位置却一直没变，这是一门艺术。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20close%20up%20of%20a%20mechanical%20keyboard%20on%20a%20clean%20cream%20desk%20with%20a%20cup%20of%20coffee%2C%20soft%20warm%20afternoon%20light%2C%20minimal%20editorial%20product%20photography&width=1200&height=800&seq=chigua-post-10&orientation=landscape',
    author: '工位隐士',
    date: '2026-08-27',
    readMinutes: 4,
    likes: 6980,
    comments: 470,
    heat: 94,
    tags: ['摸鱼', '打工人日常'],
    highlight: '真正的摸鱼高手，看起来永远是全公司最忙的那一个。',
    paragraphs: [
      '第一条法则：键盘声要均匀。太快显得焦躁，太慢显得无所事事，最理想的是那种「有条不紊」的节奏。',
      '第二条法则：屏幕要有层次。永远不要只开一个窗口，最好同时开三个，其中至少一个滚到很下面，让人一眼看不清你在干什么。',
      '第三条法则：偶尔皱眉。皱眉是「我在思考」的国际通用信号，比任何解释都有效。',
      '当然，指南归指南，真到了交活儿的时候还是得干活。我们摸的从来不是工作本身，而是那些被会议切碎的、真正属于自己的几分钟。',
    ],
  },
  {
    id: 'onesize-fits-all-tent',
    title: '网购了一件「均码」，收到后像买了个帐篷',
    channel: 'mihuo',
    channelName: '迷惑行为',
    excerpt: '商家说均码适合所有身材，穿上之后我相信了，因为它真的能装下所有人。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20flat%20lay%20of%20an%20oversized%20neutral%20knit%20sweater%20folded%20neatly%20on%20a%20soft%20beige%20surface%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20editorial%20style%2C%20no%20people&width=1200&height=800&seq=chigua-post-11&orientation=landscape',
    author: '购物车清空者',
    date: '2026-08-25',
    readMinutes: 2,
    likes: 4470,
    comments: 289,
    heat: 81,
    tags: ['外卖刺客', '公司迷惑行为'],
    highlight: '「均码」这两个字，承载了太多商家对身材的想象。',
    paragraphs: [
      '商品详情页写着「均码，适合 45-70kg」，看着挺合理，我就下单了。',
      '收到快递那天，包装盒比我预想的大了一圈。拆开之后，我终于理解了什么叫「包容性设计」——它的袖口宽到可以同时伸进两只手。',
      '我穿上照了照镜子，朋友在旁边说：「你这是穿衣服，还是搭了个凉棚？」',
      '最后的结局是它被我改造成了家里的毯子，意外地很舒服。有些衣服不适合穿出门，但很适合窝在沙发里。',
    ],
  },
  {
    id: 'gym-coach-one-more',
    title: '健身教练说「再来一个」，我说好的我这就走',
    channel: 'moyu',
    channelName: '摸鱼段子',
    excerpt: '他说的是再坚持一下，我理解的是再坚持一下就能走了。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20orange%20toned%20gym%20interior%20with%20dumbbells%20and%20a%20rolled%20towel%20on%20a%20bench%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20style%2C%20no%20people%2C%20cozy%20playful%20mood&width=1200&height=800&seq=chigua-post-12&orientation=landscape',
    author: '健身房逃兵',
    date: '2026-08-23',
    readMinutes: 3,
    likes: 3910,
    comments: 240,
    heat: 80,
    tags: ['健身失败', '打工人日常'],
    highlight: '健身最难的不是举起来，是听完「再来一个」还不走。',
    paragraphs: [
      '办卡的时候我信心满满，觉得自己会变成自律的人。现实是，我去健身房的频率和天气一样不可预测。',
      '那天教练盯着我做完最后一组，说了句「再来一个」。我的大脑立刻开始翻译：这是一个关于坚持的隐喻，但也是一个关于体力的实况播报。',
      '我说好的，然后放下器械，认真地走向了更衣室。教练在后面喊「哎哎哎」，我头也不回，步伐里带着一种凯旋的轻快。',
      '回家路上我买了杯奶茶，理由是今天确实运动了。这个逻辑我自己都觉得挺通顺的。',
    ],
  },
  {
    id: 'annual-lottery-lunch',
    title: '年会抽奖抽到「与老板共进午餐」，全公司为我鼓掌',
    channel: 'regua',
    channelName: '今日热瓜',
    excerpt: '掌声特别热烈，我怀疑大家在庆祝这个奖没落到自己头上。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20amber%20toned%20festive%20stage%20with%20a%20raffle%20drum%20and%20string%20lights%20on%20a%20cream%20background%2C%20celebration%20mood%2C%20soft%20warm%20glow%2C%20minimal%20editorial%20illustration%2C%20no%20people%20faces&width=1200&height=800&seq=chigua-post-13&orientation=landscape',
    author: '瓜田小队长',
    date: '2026-08-21',
    readMinutes: 3,
    likes: 5860,
    comments: 388,
    heat: 90,
    tags: ['年会名场面', '公司迷惑行为'],
    highlight: '那一刻我明白，掌声有时候不是祝福，是庆幸。',
    paragraphs: [
      '年会抽奖环节，主持人大声念出我的工号，说奖品是「与老板共进一顿午餐」。',
      '全场响起了我入职以来最热烈的掌声。我站起来挥手致意，笑容得体，内心复杂。',
      '坐下之后，旁边的同事悄悄问我：「你紧张吗？」我说：「我在想聊什么。」他说：「建议聊工作以外的事。」',
      '后来那顿饭比我想象的轻松，老板聊了很多他刚工作时的糗事。我忽然觉得，全场为我鼓掌可能也不全是庆幸，也许还带着一点羡慕。',
    ],
  },
  {
    id: 'neighbor-piano-duet',
    title: '邻居半夜练琴，我顺手伴奏了一段，结果他停了',
    channel: 'shadiaotujian',
    channelName: '沙雕图鉴',
    excerpt: '我本来只是想配合一下，没想到配合出了「默契」的代价。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cream%20toned%20quiet%20night%20apartment%20balcony%20with%20a%20potted%20plant%20and%20warm%20window%20light%2C%20soft%20evening%20glow%2C%20calm%20minimal%20editorial%20illustration%2C%20no%20people&width=1200&height=800&seq=chigua-post-14&orientation=landscape',
    author: '通勤观察日记',
    date: '2026-08-19',
    readMinutes: 2,
    likes: 4290,
    comments: 262,
    heat: 78,
    tags: ['宿舍名场面', '地铁奇遇'],
    highlight: '有些默契，出现得太突然，也挺让人措手不及。',
    paragraphs: [
      '晚上十一点半，隔壁传来了断断续续的钢琴声，同一段旋律反复了十几遍，看得出来是在死磕。',
      '我本来戴着耳机，后来摘下耳机跟着哼了两句，又顺手用吉他弹了个简单的和声。',
      '神奇的是，隔壁的琴声忽然跟上了我的节奏，我们居然合上了一句。然后——停了。彻底的安静。',
      '过了半分钟，隔壁轻轻敲了两下墙。我不知道那是「打扰了」还是「不错」，我回敲了两下。之后我们再没合奏过，但那晚睡得很好。',
    ],
  },
];